export const DEFAULT_GRADIENT_COLOR = "#fff";

export const DEFAULT_HEXAGON_SIDE_WIDTH = 13;

export const DEFAULT_HEXAGON_RADIUS = 2;

export const DEFAULT_SQUARE_SIDE_SIZE = 20;

export const GRADIENT_PREFIX = "gradient-";

export const STROKE_MAX_WIDTH = 10;
